export const IMPORT_TITLE_MAX_LENGTH = 60;
export const IMPORT_DESCRIPTION_MAX_LENGTH = 5000;
export const IMPORT_PURCHASE_LISTING_TYPES = ['live_goods', 'dry_goods', 'reef_art_apparel'];

/** Console listing-field keys that belong to tank services (not imported). */
export const TANK_SERVICE_LISTING_FIELD_KEYS = [
  'gallons_total',
  'water_volume_sumps',
  'price_structure',
];

/** Same Details field as tank_size (Minimum Tank Size). Omit from the import template. */
export const DUPLICATE_LISTING_FIELD_KEYS = ['min_tank_size'];

export const TANK_SERVICE_CATEGORY_IDS = ['services_tank', 'reef_events'];
export const IMPORT_SOURCE_CSV = 'csv';
export const IMPORT_SOURCE_SHOPIFY = 'shopify';

/** Must match bridge `FORUM_OVERFLOW_IMMEDIATE_CAP` in config/r2rForumNodes.js. */
export const FORUM_OVERFLOW_IMMEDIATE_CAP = 5;

/** Stamp on Finish-table Publish selected; Edit Listing must clear it. */
export const FORUM_PUBLISH_BATCH_KEY = 'forumPublishBatchId';
